import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "panel-section" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { key: 3 }
const _hoisted_6 = { key: 4 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_kendo_panelbar = _resolveComponent("kendo-panelbar")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_kendo_panelbar, { ref: "panelbar" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("p", null, _toDisplayString(_ctx.Heading), 1),
          (_ctx.options != null)
            ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.Title1) + " " + _toDisplayString(_ctx.Value1), 1))
            : (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.Title1) + " " + _toDisplayString(_ctx.Value1), 1)),
          _createElementVNode("p", null, _toDisplayString(_ctx.Title2) + " " + _toDisplayString(_ctx.Value2), 1),
          (_ctx.options != null && !_ctx.customSettingFlag)
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.Title3) + " " + _toDisplayString(_ctx.isEnable), 1))
            : _createCommentVNode("", true),
          (_ctx.options == null && !_ctx.customSettingFlag)
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.Title3) + " " + _toDisplayString(_ctx.Value3) + "%", 1))
            : _createCommentVNode("", true),
          (_ctx.customSettingFlag)
            ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.Title3) + " " + _toDisplayString(_ctx.customSettingToggleValue), 1))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ])
      ]),
      _: 3
    }, 512)
  ]))
}